import copy from '~/assets/icons/copy.svg';
import nfc from '~/assets/icons/nfc.svg';
import { CurrencyIcon } from '~/components/collections';
import { Text } from '~/components/ui/Text';
import { useWalletIcon } from '~/hooks';
import { rage, useObservable } from '~/rage';
import { Currency, formatTime, WalletType } from '~/shared';
import { maskCardNumber } from '~/utils/cardNumber';
import cardLogo from '../../assets/images/card_logo.svg';
import {
	StyledBalanceContainer,
	StyledBottomContainer,
	StyledCardNumberContainer,
	StyledContainer,
	StyledCopyButton,
	StyledTopContainer,
} from './MenuCard.styled';

const MenuCard: React.FC = () => {
	const bankBalance = useObservable(rage.bank.getBalance(WalletType.Bank));
	const rubleIcon = useWalletIcon(Currency.Ruble, true);
	const cardNumber = useObservable(rage.bank.getCardNumber());
	const bankStats = useObservable(rage.bank.getBankStats());

	const handleCopyCardNumber = () => {
		rage.input.copyToClipboard(cardNumber);
		rage.notifications.showInfo('Номер карты скопирован');
	};

	return (
		<StyledContainer>
			<StyledTopContainer>
				<img src={cardLogo} width={93} height={20} />
				<img src={nfc} width={20} height={20} />
			</StyledTopContainer>
			<StyledBalanceContainer>
				<CurrencyIcon icon={rubleIcon} size="lg" />
				<Text>{bankBalance?.toLocaleString('ru-RU')}</Text>
			</StyledBalanceContainer>
			<StyledBottomContainer>
				<StyledCardNumberContainer onClick={handleCopyCardNumber}>
					<Text style={{ fontWeight: 500 }}>{maskCardNumber(cardNumber)}</Text>
					<StyledCopyButton>
						<img src={copy} width={14} height={14} />
					</StyledCopyButton>
				</StyledCardNumberContainer>
				<Text style={{ textAlign: 'right' }}>
					{formatTime(bankStats.cardExpiresAt, '{MM} / {yy}', {
						useMoscowTimezone: true,
					})}
				</Text>
			</StyledBottomContainer>
		</StyledContainer>
	);
};

export { MenuCard };
